export default __webpack_public_path__ + "/dist/images/img1.png";